module.exports = __webpack_public_path__ + "static/media/12.bbb460f9.jpg";